export default __webpack_public_path__ + "static/media/first_sailing_holiday.33143e7b.webp";